// extracted by mini-css-extract-plugin
export default {"list":"hc--news-list--list"};